import {
    normalizeBorder,
} from './border'

export default {
    normalizeBorder,
}
